import { render, staticRenderFns } from "./EventsSingleContent.vue?vue&type=template&id=d1a19f6e&"
import script from "./EventsSingleContent.vue?vue&type=script&lang=js&"
export * from "./EventsSingleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports